import gql from "graphql-tag";

export default gql`
  fragment PinnablePostFields on PinnablePost {
    isPinned
    pinnedBy {
      _id
      fullName
    }
  }
`;
